// src/pages/DirectPage/MessageBubble.jsx
import React from 'react';
import { directPageStyles } from './styles';

// User Icon SVG
const UserIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const MessageBubble = ({ 
  message, 
  isCurrentUser, 
  showAvatar, 
  seller,
  currentUser,
  isFirstInGroup
}) => {
  const bubbleStyle = {
    ...directPageStyles.messageBubbleBase,
    ...(isCurrentUser ? directPageStyles.messageBubbleSent : directPageStyles.messageBubbleReceived)
  };

  // Format timestamp
  const formatTime = (timestamp) => {
    if (!timestamp?.toDate) return '';
    const date = timestamp.toDate();
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  };

  // Get avatar for the message sender
  const getAvatar = () => {
    if (isCurrentUser) {
      return currentUser?.profilePic || null;
    }
    return seller?.profilePic || null;
  };

  const avatarUrl = getAvatar();

  // Container style with proper spacing
  const containerStyle = {
    ...directPageStyles.messageContainer,
    ...(isCurrentUser ? directPageStyles.messageContainerSent : directPageStyles.messageContainerReceived),
    marginTop: isFirstInGroup ? '16px' : '2px',
    marginBottom: showAvatar ? '4px' : '0px'
  };

  return (
    <div style={containerStyle}>
      {/* Left side avatar for received messages */}
      {!isCurrentUser && (
        <div style={directPageStyles.messageAvatarContainer}>
          {showAvatar ? (
            avatarUrl ? (
              <img 
                src={avatarUrl} 
                alt="avatar" 
                style={directPageStyles.messageAvatar}
              />
            ) : (
              <div style={directPageStyles.messageAvatarPlaceholder}>
                <UserIcon />
              </div>
            )
          ) : null}
        </div>
      )}
      
      {/* Message bubble with timestamp */}
      <div style={directPageStyles.messageBubbleWrapper}>
        <div style={bubbleStyle}>
          {message.text}
        </div>
        {showAvatar && message.createdAt && (
          <div style={isCurrentUser ? directPageStyles.timestampSent : directPageStyles.timestampReceived}>
            {formatTime(message.createdAt)}
          </div>
        )}
      </div>
      
      {/* Right side avatar for sent messages */}
      {isCurrentUser && (
        <div style={directPageStyles.messageAvatarContainer}>
          {showAvatar ? (
            avatarUrl ? (
              <img 
                src={avatarUrl} 
                alt="avatar" 
                style={directPageStyles.messageAvatar}
              />
            ) : (
              <div style={directPageStyles.messageAvatarPlaceholder}>
                <UserIcon />
              </div>
            )
          ) : null}
        </div>
      )}
    </div>
  );
};

export default MessageBubble;